/* House of Hannah — product page
   Variant selection, gallery switching, delivery checker, sticky ATC. */
(function () {
  'use strict';

  const section = document.querySelector('[data-product-section]');
  if (!section) return;

  const jsonEl = document.querySelector('[data-product-json]');
  const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;

  /* Record in recently viewed */
  if (product && window.hohRecentlyViewed) {
    window.hohRecentlyViewed.add(product.handle);
  }

  /* ---------------- Gallery ---------------- */
  const thumbs = section.querySelectorAll('[data-gallery-thumb]');
  const mediaItems = section.querySelectorAll('[data-gallery-media]');

  function activateMedia(index) {
    mediaItems.forEach((m) => m.classList.toggle('is-active', Number(m.dataset.mediaIndex) === index));
    thumbs.forEach((t) => t.classList.toggle('is-active', Number(t.dataset.mediaIndex) === index));
    const target = section.querySelector(`[data-gallery-media][data-media-index="${index}"]`);
    if (target && window.matchMedia('(min-width: 990px)').matches) {
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => activateMedia(Number(thumb.dataset.mediaIndex)));
  });

  /* Track which stacked image is in view to sync the thumbnail rail */
  if ('IntersectionObserver' in window && mediaItems.length > 1) {
    const sync = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = Number(entry.target.dataset.mediaIndex);
            thumbs.forEach((t) => t.classList.toggle('is-active', Number(t.dataset.mediaIndex) === index));
          }
        });
      },
      { rootMargin: '-40% 0px -50% 0px' }
    );
    mediaItems.forEach((m) => sync.observe(m));
  }

  /* ---------------- Image lightbox / zoom ---------------- */
  const lightbox = document.querySelector('[data-product-lightbox]');
  if (lightbox) {
    const lightboxImage = lightbox.querySelector('[data-lightbox-image]');
    const stage = lightbox.querySelector('[data-lightbox-stage]');

    const openLightbox = (src, alt) => {
      if (!src) return;
      lightboxImage.src = src;
      lightboxImage.alt = alt || '';
      lightbox.classList.add('is-open');
      lightbox.classList.remove('is-zoomed');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
      lightbox.classList.remove('is-open', 'is-zoomed');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    section.querySelectorAll('.main-product__image').forEach((img) => {
      img.addEventListener('click', () => openLightbox(img.currentSrc || img.src, img.alt));
    });

    lightboxImage.addEventListener('click', (event) => {
      event.stopPropagation();
      lightbox.classList.toggle('is-zoomed');
      if (lightbox.classList.contains('is-zoomed') && stage) {
        const rect = lightboxImage.getBoundingClientRect();
        stage.scrollTo({
          left: (event.clientX - rect.left) / rect.width * stage.scrollWidth - stage.clientWidth / 2,
          top: (event.clientY - rect.top) / rect.height * stage.scrollHeight - stage.clientHeight / 2,
        });
      }
    });

    lightbox.querySelector('[data-lightbox-close]').addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox || event.target === stage) closeLightbox();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
    });
  }

  /* ---------------- Generic share (native share sheet + copy fallback) ---------------- */
  const shareWrap = section.querySelector('[data-share]');
  if (shareWrap) {
    const shareButton = shareWrap.querySelector('[data-share-button]');
    const feedback = shareWrap.querySelector('[data-share-feedback]');

    const flash = (message) => {
      if (!feedback) return;
      feedback.textContent = message;
      feedback.classList.add('is-visible');
      window.setTimeout(() => feedback.classList.remove('is-visible'), 2400);
    };

    shareButton.addEventListener('click', async () => {
      const shareUrl = shareWrap.dataset.shareUrl || window.location.href;
      const shareTitle = shareWrap.dataset.shareTitle || document.title;

      if (navigator.share) {
        try {
          await navigator.share({ title: shareTitle, text: shareTitle, url: shareUrl });
        } catch (err) {
          /* user cancelled — no-op */
        }
        return;
      }

      try {
        await navigator.clipboard.writeText(shareUrl);
        flash('Link copied');
      } catch (err) {
        window.prompt('Copy this link:', shareUrl);
      }
    });
  }

  /* ---------------- Variant picker ---------------- */
  const picker = section.querySelector('[data-variant-picker]');

  function selectedOptions() {
    const options = [];
    section.querySelectorAll('[data-option-index]').forEach((fieldset) => {
      const checked = fieldset.querySelector('input:checked');
      options[Number(fieldset.dataset.optionIndex)] = checked ? checked.value : null;
    });
    return options;
  }

  function findVariant(options) {
    return product.variants.find((variant) =>
      variant.options.every((value, index) => value === options[index])
    );
  }

  function formatMoney(cents) {
    return (
      '₹ ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    );
  }

  function renderPrice(variant) {
    const markup =
      variant.compare_at_price && variant.compare_at_price > variant.price
        ? `<div class="price price--large"><span class="price__sale">${formatMoney(variant.price)}</span><s class="price__compare">${formatMoney(variant.compare_at_price)}</s></div>`
        : `<div class="price price--large"><span class="price__sale">${formatMoney(variant.price)}</span></div>`;
    const wrapper = section.querySelector('[data-price-wrapper] .price');
    if (wrapper) wrapper.outerHTML = markup;
    const sticky = document.querySelector('[data-price-wrapper-sticky] .price');
    if (sticky) sticky.outerHTML = markup.replace('price--large', '');
    renderAadiNote(variant);
  }

  // Mirrors the Liquid maths in aadi-sale-price-note: exact paise, then ceiling
  // to the whole rupee, shown without trailing zeros. Ceiling, never nearest —
  // rounding down would quote less than checkout charges.
  function renderAadiNote(variant) {
    section.querySelectorAll('[data-aadi-note]').forEach((note) => {
      const percent = Number(note.dataset.aadiPercent);
      const value = note.querySelector('[data-aadi-note-value]');
      if (!value || !percent) return;
      const paise = Math.floor((variant.price * (100 - percent)) / 100);
      const rupees = Math.ceil(paise / 100);
      value.textContent = 'Rs. ' + rupees.toLocaleString('en-IN');
    });
  }

  /* ---------------- Add to cart + WhatsApp links ---------------- */
  const buyArea = section.querySelector('[data-product-buy]');
  const buyLink = section.querySelector('[data-whatsapp-buy]');
  const quantityInput = section.querySelector('[data-quantity-input]');
  const addButton = section.querySelector('[data-add-button]');
  const addText = section.querySelector('[data-add-button-text]');
  const stickyAdd = document.querySelector('[data-sticky-add]');
  const dynamicCheckout = section.querySelector('[data-dynamic-checkout]');

  function currentQuantity() {
    const value = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  function buildWhatsAppHref(variant) {
    if (!buyArea) return '#';
    const base = buyArea.dataset.waBase;
    const title = buyArea.dataset.productTitle || (product ? product.title : '');
    const url = buyArea.dataset.productUrl || window.location.href;
    const qty = currentQuantity();
    const sku = variant ? variant.sku : buyArea.dataset.productCode;
    const optionName = variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';
    const price = variant ? formatMoney(variant.price) : '';

    let message = "Hi House of Hannah! I'd like to order:\n" + title;
    if (sku) message += ' (Code: ' + sku + ')';
    if (optionName) message += '\nOption: ' + optionName;
    message += '\nQuantity: ' + qty;
    if (price) message += '\nPrice: ' + price;
    message += '\n' + url;
    return base + encodeURIComponent(message);
  }

  function updateWhatsApp(variant) {
    if (buyLink) buyLink.setAttribute('href', buildWhatsAppHref(variant));
  }

  function updateAvailability(variant) {
    const available = variant ? variant.available : false;
    const label = addText && addText.dataset.addLabel ? addText.dataset.addLabel : 'Add to cart';
    if (addButton) addButton.disabled = !available;
    if (addText) addText.textContent = available ? label : 'Sold out';
    if (stickyAdd) {
      stickyAdd.disabled = !available;
      stickyAdd.textContent = available ? label : 'Sold out';
    }
    if (dynamicCheckout) dynamicCheckout.hidden = !available; // hide Buy It Now when sold out
  }

  function updateVariant() {
    if (!product) return;
    const variant = findVariant(selectedOptions());
    const idInput = section.querySelector('[data-variant-id]');

    if (!variant) {
      if (addButton) addButton.disabled = true;
      if (addText) addText.textContent = window.variantStrings ? window.variantStrings.unavailable : 'Unavailable';
      return;
    }

    if (idInput) idInput.value = variant.id;
    renderPrice(variant);

    const codeEl = section.querySelector('[data-product-code] span');
    if (codeEl && variant.sku) codeEl.textContent = variant.sku;

    updateAvailability(variant);
    updateWhatsApp(variant);

    if (variant.featured_media) {
      const target = section.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
      if (target) activateMedia(Number(target.dataset.mediaIndex));
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  if (picker) {
    picker.addEventListener('change', updateVariant);
  }

  /* Rebuild the WhatsApp message whenever quantity changes */
  if (quantityInput) {
    quantityInput.addEventListener('change', () => {
      updateWhatsApp(product ? findVariant(selectedOptions()) : null);
    });
  }

  /* ---------------- Delivery checker ---------------- */
  const checker = section.querySelector('[data-delivery-checker]');
  if (checker) {
    const input = checker.querySelector('[data-delivery-input]');
    const submit = checker.querySelector('[data-delivery-submit]');
    const message = checker.querySelector('[data-delivery-message]');

    const check = () => {
      const value = (input.value || '').trim();
      if (/^[1-9][0-9]{5}$/.test(value)) {
        message.textContent = message.dataset.availableText
          ? message.dataset.availableText.replace('[pincode]', value)
          : `Great news — we deliver to ${value}. Estimated delivery in 4–7 days.`;
        message.classList.remove('is-error');
        message.classList.add('is-success');
      } else {
        message.textContent = 'Please enter a valid 6-digit PIN code.';
        message.classList.remove('is-success');
        message.classList.add('is-error');
      }
    };

    submit.addEventListener('click', check);
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        check();
      }
    });
  }

  /* ---------------- Sticky mobile bar ---------------- */
  const stickyBar = document.querySelector('[data-sticky-atc]');
  if (stickyBar && buyArea && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          stickyBar.classList.toggle('is-visible', show);
          document.body.classList.toggle('has-sticky-atc', show);
        });
      },
      { threshold: 0 }
    );
    observer.observe(buyArea);
  }

  if (stickyAdd) {
    stickyAdd.addEventListener('click', () => {
      const form = section.querySelector('form[data-product-form]');
      if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }

  /* Initialise buttons on load (covers default variant + quantity) */
  {
    const initial = product ? findVariant(selectedOptions()) || product.variants[0] : null;
    updateAvailability(initial);
    updateWhatsApp(initial);
  }
})();
